import format from 'date-fns/format';

const formatDate = (date: Date) => format(date, 'yyyy-MM-dd');

export { formatDate };
